/* eslint-disable */
import messageTypes from '@ringcentral-integration/commons/enums/messageTypes';
export default {
  title: 'Viestit',
  search: 'Haku...',
  composeText: 'Kirjoita tekstiviesti',
  noMessages: 'Ei viestejä',
  noSearchResults: 'Vastaavia tallenteita ei löytynyt',
  [messageTypes.all]: 'Kaikki',
  [messageTypes.voiceMail]: 'Ääni',
  [messageTypes.text]: 'Tekstiviesti',
  [messageTypes.fax]: 'Faksi',
} as const;

// @key: @#@"title"@#@ @source: @#@"Messages"@#@
// @key: @#@"search"@#@ @source: @#@"Search..."@#@
// @key: @#@"composeText"@#@ @source: @#@"Compose Text"@#@
// @key: @#@"noMessages"@#@ @source: @#@"No Messages"@#@
// @key: @#@"noSearchResults"@#@ @source: @#@"No matching records found"@#@
// @key: @#@"[messageTypes.all]"@#@ @source: @#@"All"@#@
// @key: @#@"[messageTypes.voiceMail]"@#@ @source: @#@"Voice"@#@
// @key: @#@"[messageTypes.text]"@#@ @source: @#@"Text"@#@
// @key: @#@"[messageTypes.fax]"@#@ @source: @#@"Fax"@#@
